import { create, StateCreator } from 'zustand'

interface IScrollBarRef {
  id: string
  scrollTo: (y: number) => void
}

interface IScrollBarState {
  scrollBars: Record<string, IScrollBarRef>
  registerScrollBar: (id: string, scrollTo: (y: number) => void) => void
  unregisterScrollBar: (id: string) => void
  scrollTo: (id: string, y: number) => void
}

const createScrollBarStore: StateCreator<IScrollBarState> = (set, get) => ({
  scrollBars: {},
  registerScrollBar: (id: string, scrollTo: (y: number) => void) =>
    set((state) => ({
      scrollBars: {
        ...state.scrollBars,
        [id]: { id, scrollTo },
      },
    })),
  unregisterScrollBar: (id: string) =>
    set((state) => {
      const newScrollBars = { ...state.scrollBars }
      delete newScrollBars[id]
      return { scrollBars: newScrollBars }
    }),
  scrollTo: (id: string, y: number) => {
    const scrollBar = get().scrollBars[id]
    if (scrollBar) {
      scrollBar.scrollTo(y)
    }
  },
})

export const useScrollBarStore = create<IScrollBarState>()(createScrollBarStore)
